/**
 * Created by ganlu on 24/03/2017.
 */
export default () => {
    return function (scope, elem) {
        elem.on('click touchstart', (e) => {
            elem.removeClass('active');
            $('.mobile-side-nav').removeClass('active');
            $('body').removeClass('no-scroll');
            e.stopPropagation();
        });
    };
};



// WEBPACK FOOTER //
// ./src/app/components/face/face-header/side-nav-mask-control.directive.js